<template>
    <div class="container-fluid">

        <div class="page-heading mb-4">
            <p class="page-eyebrow">EVENT PROGRAMME</p>
            <h1 class="h3 mb-1 text-gray-800">Add event detail</h1>
            <p class="mb-0 text-muted">Create the session information delegates need for this event.</p>
        </div>

        <EventDetailForm :is-new="true"></EventDetailForm>
    </div>

</template>

<script>
import {defineComponent} from 'vue'
import EventDetailForm from '@/components/event/EventDetailForm.vue';


export default defineComponent({
    name: "EventDetailAddPage",
    components: {EventDetailForm}
})
</script>

<style scoped>
.page-heading{border-bottom:1px solid #e2e6ea;padding-bottom:1rem}.page-eyebrow{color:#426cc6;font-size:.72rem;font-weight:700;letter-spacing:.08em;margin:0 0 .35rem}
</style>
